import { render, staticRenderFns } from "./StarMap.vue?vue&type=template&id=b8c10a78&scoped=true&"
import script from "./StarMap.vue?vue&type=script&lang=js&"
export * from "./StarMap.vue?vue&type=script&lang=js&"
import style0 from "./StarMap.vue?vue&type=style&index=0&id=b8c10a78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8c10a78",
  null
  
)

export default component.exports